import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import {
  OverlapHeroWrapper,
  Overlap,
  AvatarWrapper,
  ProfileWrapper,
  ProfileText,
} from './OverlapHero.styles'
import BgImg from 'gatsby-background-image-es5'
import { GatsbyImage } from 'gatsby-plugin-image'
import { convertToBgImage } from 'gbimage-bridge'

const OverlapHero = ({ hero, quote, profileImg, profileName, role }) => {
  const isIos =
    typeof navigator !== 'undefined' &&
    navigator.userAgent.match(/Mac/) &&
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2
  const bgImage = convertToBgImage(hero)

  return (
    <OverlapHeroWrapper>
      <StyledBg className="overlapHero" fluid={bgImage.fluid} isIos={isIos} />
      <Overlap>
        <h4>{quote}</h4>
        <ProfileWrapper>
          <AvatarWrapper>
            <GatsbyImage
              image={profileImg}
              alt="Hero image"
              style={{ borderRadius: `50%`, border: `1px solid #979797` }}
            />
          </AvatarWrapper>

          <ProfileText>
            <h5>{profileName}</h5>
            <p>{role}</p>
          </ProfileText>
        </ProfileWrapper>
      </Overlap>
    </OverlapHeroWrapper>
  )
}
const StyledBg = styled(BgImg)`
  background-attachment: ${({ isIos }) =>
    isIos ? 'intial' : 'fixed'} !important;
  background-position: center !important;
  width: 100%;
  height: 400px;

  ${({ isIos }) =>
    isIos && '&:before, &:after {background-attachment: initial !important}'}
  @supports (-webkit-overflow-scrolling: touch) {
    background-attachment: initial !important;

    &::before,
    &::after {
      background-attachment: initial !important;
    }
  }

  @supports (-webkit-text-size-adjust: none) and
    (-webkit-marquee-repetition: infinite) and (object-fit: fill) {
    background-attachment: initial !important;

    &::before,
    &::after {
      background-attachment: initial !important;
    }
  }
  @media only screen and (max-width: 748px) {
    &::before,
    &::after {
      background-attachment: initial !important;
    }
  }
`
OverlapHero.propTypes = {
  hero: PropTypes.object.isRequired,
  quote: PropTypes.string.isRequired,
}

export default OverlapHero
